import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const footerCategories = [
  categories.slice(0, 4),
  categories.slice(4, 8),
  categories.slice(8, 12),
  categories.slice(12, 14),
];

const footerColumns = [
  { title: "Categories", items: footerCategories[0] },
  { title: "More", items: footerCategories[1] },
  { title: "Extras", items: footerCategories[2] },
  { title: "Company", items: [
    ...footerCategories[3],
    { name: "Guide", url: "/blog/itaobuyspreadsheet-guide", icon: "ri-article-line", isInternal: true },
    { name: "Main Site", url: "https://kaspreadsheet.com", icon: "ri-external-link-line" },
  ]},
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[320px] flex-shrink-0">
            <Link to="/" className="font-heading text-2xl md:text-3xl font-semibold tracking-tight inline-block cursor-pointer">
              itaobuy<span className="text-accent-400">.</span>casa
            </Link>
            <p className="mt-4 text-sm text-background-300/80 leading-relaxed max-w-[260px]">
              Your structured shopping spreadsheet guide for smarter, faster online buying decisions.
            </p>
            <div className="mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center space-x-2 px-6 py-3 bg-accent-500 text-background-50 text-sm font-label font-medium rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>buy it now</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 flex-1">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-label font-semibold text-background-100 mb-4 uppercase tracking-wider">
                  {col.title}
                </h4>
                <ul className="space-y-2.5">
                  {col.items.map((item) => (
                    <li key={item.name}>
                      {"isInternal" in item && item.isInternal ? (
                        <Link
                          to={item.url}
                          className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer font-label"
                        >
                          {item.name}
                        </Link>
                      ) : (
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer font-label"
                        >
                          {item.name}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-300/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300/50 font-label">
            &copy; {new Date().getFullYear()} itaobuy.casa. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md border border-background-300/20 text-background-300/50 hover:text-background-100 hover:border-background-300/40 transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md border border-background-300/20 text-background-300/50 hover:text-background-100 hover:border-background-300/40 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md border border-background-300/20 text-background-300/50 hover:text-background-100 hover:border-background-300/40 transition-colors cursor-pointer">
              <i className="ri-pinterest-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-md border border-background-300/20 text-background-300/50 hover:text-background-100 hover:border-background-300/40 transition-colors cursor-pointer">
              <i className="ri-tiktok-line text-sm"></i>
            </a>
          </div>
          <a href="#" className="text-xs text-background-300/50 hover:text-background-100 transition-colors font-label whitespace-nowrap">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}